import { createAsyncThunk } from '@reduxjs/toolkit';
import { stepsActions } from './index';
export const setStep = createAsyncThunk('', async (step, { dispatch }) => {
    dispatch(stepsActions._setStep(step));
});
